/**
 * 线上环境
 */
export const ONLINEHOST_FW = 'https://www.emof.cn/index.php'
export const ONLINEHOST_YXB = 'https://yxb.emof.cn/index.php/'
/**
 * 测试环境
 */
export const QAHOST_FW = 'https://www.emof.cn/index.php'
export const QAHOST_YXB = 'https://yxb.emof.cn/index.php/'
// export const QAHOST_YXB = 'http://192.168.2.143:8125'
// export const QAHOST_YXB = 'http://yxbpre.zhichenghui.org.cn'

export const BASE_URL_FW = process.env.NODE_ENV === 'production' ? ONLINEHOST_FW : QAHOST_FW
export const BASE_URL_YXB = process.env.NODE_ENV === 'production' ? ONLINEHOST_YXB : QAHOST_YXB

//请求类型判断
export const REQUEST_TYPE_FW  = 'REQUEST_TYPE_FW'
export const REQUEST_TYPE_YXB = 'REQUEST_TYPE_YXB'

export const DOMAIN=  `https://yxb.emof.cn`

//文件地址
export const FILE_PATH_FW=  `https://www.emof.cn`
export const FILE_PATH_YXB=  `${BASE_URL_YXB}`.replace('index.php/','')

//文件上传地址
export const FILE_UPLOAD_HOST_FW = `${BASE_URL_YXB}Index/Other/upload`
export const FILE_UPLOAD_HOST = 'https://upload-z2.qiniup.com/'


/*
* 百度编辑器配置
* */
export const bdEditConfig = () => {
    return {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 320,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        // serverUrl: requestUrl + '/editor/controller.php',
        serverUrl: FILE_PATH_YXB + '/editor/controller.php',
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: '/vw/UEditor/'
    }
}


/*
* 缓存字段
* */
export const localAnStore = [
    {
        key: 'token',
        type: 'localStorage'
    },
    {
        key: 'user',
        type: 'localStorage'
    },
    {
        key: 'emofUserTokenSafer',
        type: 'localStorage'
    },
    {
        key: 'cookie_user',
        type: 'cookie',
        day: 365,
        path: '/',
    },
]
